import { RelatedDataEntity } from '@mark43/cad-api';
import { LinkText } from '../../../common/components/link-text';
import { createCell, TSimpleTableProps } from '../../../common/components/simple-table';
import { formatMonthDayYearHoursMinutes } from '../../../common/helpers/utils';

/**
 * Helper to format `RelatedDataEntity` into the format our SimpleTable expects
 */
export function generateRowData(
    relatedEntities: RelatedDataEntity[],
    onClick: (entityId: number) => void
): TSimpleTableProps['rows'] {
    return relatedEntities.map((relatedEntity) => {
        return [
            createCell({ content: formatMonthDayYearHoursMinutes(relatedEntity.createdDateUtc) }),
            createCell({ content: relatedEntity.title, subtitle: relatedEntity.subtitle }),
            createCell({
                content: (
                    <LinkText
                        key="case"
                        onClick={(e) => {
                            // We need to stop propagation here because otherwise clicking this link
                            // will trigger a `focus` call on the panel,
                            // which makes this panel still appear at the top of the stack,
                            // instead of the newly opened panel (for the cases where this handler
                            // opens a new panel)
                            e.stopPropagation();
                            onClick(relatedEntity.entityId);
                        }}
                        data-testid="related-event-link"
                    >
                        {relatedEntity.entityNumber}
                    </LinkText>
                ),
            }),
        ];
    });
}
